import { IconBase, IconProps, IconWeight } from '@phosphor-icons/react';
import { forwardRef, ReactElement } from 'react';

import { IconType } from './IconTypes';

const Icon: IconType = ({ color }) => (
  <>
    <rect width="24" height="24" fill="white" />
    <rect
      x="5.75"
      y="2.75"
      width="12"
      height="19.5"
      rx="1.25"
      stroke={color}
      strokeWidth="1.5"
    />
    <rect
      x="10.25"
      y="19.25"
      width="3"
      height="0.5"
      rx="0.25"
      fill="#D9D9D9"
      stroke={color}
      strokeWidth="0.5"
    />
    <rect x="12" y="6" width="12" height="12" rx="6" fill="white" />
    <path
      d="M18 7.125C17.0358 7.125 16.0933 7.41091 15.2916 7.94659C14.4899 8.48226 13.8651 9.24363 13.4961 10.1344C13.1271 11.0252 13.0306 12.0054 13.2187 12.9511C13.4068 13.8967 13.8711 14.7654 14.5529 15.4471C15.2346 16.1289 16.1033 16.5932 17.0489 16.7813C17.9946 16.9694 18.9748 16.8729 19.8656 16.5039C20.7564 16.1349 21.5177 15.5101 22.0534 14.7084C22.5891 13.9067 22.875 12.9642 22.875 12C22.8736 10.7075 22.3596 9.46831 21.4456 8.55436C20.5317 7.64042 19.2925 7.12636 18 7.125ZM20.1403 11.1403L17.5153 13.7653C17.4805 13.8002 17.4391 13.8278 17.3936 13.8467C17.3481 13.8656 17.2993 13.8753 17.25 13.8753C17.2007 13.8753 17.1519 13.8656 17.1064 13.8467C17.0609 13.8278 17.0195 13.8002 16.9847 13.7653L15.8597 12.6403C15.7893 12.5699 15.7498 12.4745 15.7498 12.375C15.7498 12.2755 15.7893 12.1801 15.8597 12.1097C15.9301 12.0393 16.0255 11.9998 16.125 11.9998C16.2245 11.9998 16.3199 12.0393 16.3903 12.1097L17.25 12.9698L19.6097 10.6097C19.6445 10.5748 19.6859 10.5472 19.7314 10.5284C19.7769 10.5095 19.8257 10.4998 19.875 10.4998C19.9243 10.4998 19.9731 10.5095 20.0186 10.5284C20.0641 10.5472 20.1055 10.5748 20.1403 10.6097C20.1752 10.6445 20.2028 10.6859 20.2216 10.7314C20.2405 10.7769 20.2502 10.8257 20.2502 10.875C20.2502 10.9243 20.2405 10.9731 20.2216 11.0186C20.2028 11.0641 20.1752 11.1055 20.1403 11.1403Z"
      fill={color}
    />
  </>
);

const buildWeights = (color: string) =>
  new Map<IconWeight, ReactElement>([
    ['bold', <Icon color={color} strokeWidth={24} />],
    ['duotone', <Icon color={color} strokeWidth={16} opacity={0.2} />],
    ['fill', <Icon color={color} strokeWidth={16} opacity={1} />],
    ['light', <Icon color={color} strokeWidth={12} />],
    ['thin', <Icon color={color} strokeWidth={8} />],
    ['regular', <Icon color={color} strokeWidth={8} />],
  ]);

export const PhoneVerification = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase
    ref={ref}
    {...props}
    weights={buildWeights(props.color ?? 'currentColor')}
    viewBox="0 0 24 24"
    fill="none"
  />
));

PhoneVerification.displayName = 'PhoneVerification';
